import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import FeatureFlag, { FeatureFlags } from '../lib/feature-flags';

const FeatureFlagsContext = createContext<FeatureFlags>({});

const FeatureFlagsContextProvider = ({
  children,
  appEnv,
  userId,
}: {
  children: ReactNode;
  appEnv: 'dev' | 'prod';
  userId?: string;
}) => {
  const [featureFlags, setFeatureFlags] = useState<FeatureFlags>({});
  useEffect(() => {
    const getFeatureFlags = async () => {
      const featureFlagInstance = FeatureFlag.getInstance(appEnv, userId);
      try {
        const flags = await featureFlagInstance.getFlags();
        setFeatureFlags(flags || {});
      } catch (error: unknown) {
        datadogLogs.logger.error(
          'Error fetching feature flags in FeatureFlagsContext in feature-flag',
          {},
          error as Error,
        );
      }
    };
    getFeatureFlags();
  }, []);

  return (
    <FeatureFlagsContext.Provider value={featureFlags}>{children}</FeatureFlagsContext.Provider>
  );
};

const useFeatureFlagContext = () => {
  const context = useContext(FeatureFlagsContext);
  return context;
};

export { FeatureFlagsContextProvider, useFeatureFlagContext };
